import React from 'react'

import { Col } from '../../../../../../../packages/kiti/components/structure/Grid'
import { useForm } from '../../../../../../../packages/kiti/components/form/form/FormHandler'
import FormItem from '../../../../../../../packages/kiti/components/form/form/FormItem'
import LevelsLoader, { useLevels } from './_load/LevelsLoader'
import PlaceLevelSelect from '../../../../../../../containers/placeLevels/select/PlaceLevelSelect'

const PlaceLevelsInputs = () => {
  const form = useForm()
  const levels = useLevels()

  return levels.map((level, index) => {
    const isName = index === levels.length - 1
    const parentLevel = levels[index - 1]
    const parentPlaceLevelId = form.payload[`placeLevel${parentLevel?.id}`]?.id
    const disabled = index > 0 && !isName && !parentPlaceLevelId
    const field = isName ? 'name' : `placeLevel${level.id}`

    return (
      <Col width="50%" width_sm="100%" key={level.id}>
        <FormItem
          label={level.name}
          path={['payload', field]}
          Input={!isName && PlaceLevelSelect}
          disabled={disabled}
          parentIds={parentPlaceLevelId}
          types={form.payload?.type}
          levelIds={level.id}
        />
      </Col>
    )
  })
}

const Wrapper = () => {
  const form = useForm()

  return (
    <LevelsLoader type={form.payload?.type}>
      <PlaceLevelsInputs />
    </LevelsLoader>
  )
}

export default Wrapper
